(function() {
  if (window.JomoDeliveryData) return;
  const requests = new Map();

  window.JomoDeliveryData = {
    loadJson(url) {
      if (!requests.has(url)) {
        // Shared across components: disconnecting one consumer must not abort
        // another consumer's request. Consumers guard their own lifecycle.
        const request = fetch(url, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error(`Delivery zone data returned ${response.status}`);
          return response.json();
        });
        requests.set(url, request);
        request.catch(() => {
          if (requests.get(url) === request) requests.delete(url);
        });
      }
      return requests.get(url);
    }
  };
})();
